export default __webpack_public_path__ + "static/media/img_baseBunnyCrochet_grey_p.a4c79a84.jpg";